import { useRef, useCallback, useMemo } from "react";

export const useHaptics = () => {
  const lastVibration = useRef(0);
  
  // Check media queries once on mount
  const { isCoarsePointer, prefersReducedMotion } = useMemo(() => {
    if (typeof window === "undefined") {
      return { isCoarsePointer: false, prefersReducedMotion: false };
    }
    return {
      isCoarsePointer: window.matchMedia("(pointer: coarse)").matches,
      prefersReducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    };
  }, []);

  const triggerHaptic = useCallback(() => {
    // Only vibrate on touch devices
    if (!isCoarsePointer) return;
    
    // Respect accessibility preferences
    if (prefersReducedMotion) return;
    
    // Check browser support
    if (!navigator.vibrate) return;
    
    // Rate limit: max once every 250ms
    const now = Date.now();
    if (now - lastVibration.current < 250) return;
    
    lastVibration.current = now;
    navigator.vibrate(10);
  }, [isCoarsePointer, prefersReducedMotion]);

  return { triggerHaptic, isCoarsePointer, prefersReducedMotion };
};

// Standalone function for use outside React components
let lastStandaloneVibration = 0;

export const triggerHaptic = () => {
  if (typeof window === "undefined") return;
  
  const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  
  if (!isCoarsePointer || prefersReducedMotion || !navigator.vibrate) return;
  
  const now = Date.now();
  if (now - lastStandaloneVibration < 250) return;
  
  lastStandaloneVibration = now;
  navigator.vibrate(10);
};
